import { EmptyState } from "@/components/primitives";

export function ComingSoon({ feature }: { feature: string }) {
  return (
    <EmptyState title={`${feature} are coming soon`}>
      This area is intentionally parked while Cosmos focuses on course Q&A,
      journey commands, approvals, source governance, and the data explorer.
    </EmptyState>
  );
}
